var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchAds = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 121,
  height: 77,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#searchAds_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#A4ADB4",
  strokeWidth: 4,
  d: "M18.625 58.5V67a8 8 0 0 0 8 8h68a8 8 0 0 0 8-8V9.5a8 8 0 0 0-8-8h-68a8 8 0 0 0-8 8V12"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#A4ADB4",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M23.25 46.375 9 60.625"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39.875,
  cy: 29.75,
  r: 21.375,
  stroke: "#A4ADB4",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A4ADB4",
  d: "M47.332 37.507h-5.415V22.234h5.46q2.303 0 3.967.918a6.2 6.2 0 0 1 2.557 2.617q.903 1.708.903 4.087 0 2.386-.903 4.101a6.2 6.2 0 0 1-2.572 2.633q-1.67.917-3.998.917m-2.185-2.767h2.05q1.433 0 2.409-.507.984-.514 1.477-1.588.5-1.08.5-2.79 0-1.692-.5-2.766-.492-1.074-1.47-1.58Q48.638 25 47.206 25h-2.058zM28.841 37.507h-3.46l5.272-15.273h4.162l5.264 15.273h-3.46l-3.825-11.783h-.12zm-.216-6.003h8.173v2.52h-8.173z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#A4ADB4",
  strokeWidth: 2,
  d: "M56.125 7.5h40.5M62.125 13.5h34.5M65.125 19.5h31.5M66.625 25.5h30M66.625 31.5h30M65.125 37.5h31.5M62.125 43.5h34.5M57.625 49.5h39M24.625 55.5h72M24.625 61.5h72M24.625 67.5h72"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "searchAds_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.25 0h120v76.5H.25z"
})))));
export default SvgSearchAds;